var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
/** Format an ISO date/datetime as DD/MM/YYYY (the Australian PAS convention). */
function fmtDob(iso) {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    return m ? `${m[3]}/${m[2]}/${m[1]}` : iso.slice(0, 10);
}
let PasBanner = class PasBanner extends LitElement {
    constructor() {
        super(...arguments);
        this.patient = null;
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; background: var(--color-slate-900); color: var(--color-white);
            padding: 13px 18px; font-family: var(--font-base); }
    .row { display: flex; gap: 18px; align-items: center; flex-wrap: wrap; }
    .name { font-family: var(--font-display); font-weight: 600; font-size: 16px; letter-spacing: .005em; }
    .meta { color: var(--color-white); font-size: 13px; display: inline-flex; align-items: center; gap: 6px; }
    .meta .k { color: var(--color-slate-400); font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; }
    .sep { width: 1px; height: 14px; background: var(--color-slate-700); }
    .alert { margin-top: 8px; display: inline-flex; align-items: center; gap: 7px; font-size: 12px;
             color: #FCD34D; background: rgba(245,158,11,.12); border: 1px solid rgba(245,158,11,.25);
             padding: 3px 10px; border-radius: 20px; }
  `; }
    render() {
        if (!this.patient)
            return html `<div class="row">No patient loaded</div>`;
        const p = this.patient;
        return html `
      <div class="row">
        <div class="name">${p.name.given} ${p.name.family}</div>
        <div class="meta"><span class="k">Age</span> ${p.computedAge}</div>
        <div class="sep"></div>
        <div class="meta"><span class="k">Sex</span> ${p.sex}</div>
        ${p.date_of_birth ? html `<div class="sep"></div><div class="meta"><span class="k">DOB</span> ${fmtDob(p.date_of_birth)}</div>` : ""}
        <div class="sep"></div>
        <div class="meta"><span class="k">MRN</span> ${p.identifiers.mrn}</div>
        <div class="sep"></div>
        <div class="meta"><span class="k">IHI</span> ${p.identifiers.ihi}</div>
      </div>
      ${p.alerts.length ? html `<div class="alert">⚠ ${p.alerts.join(" · ")}</div>` : ""}
    `;
    }
};
__decorate([
    property({ attribute: false })
], PasBanner.prototype, "patient", void 0);
PasBanner = __decorate([
    customElement("pas-banner")
], PasBanner);
export { PasBanner };
